export default "__VITE_ASSET__3b3417d0__"